import React from 'react'
import Box from '../components/Box'

export default function Section9() {
    return (
        <div className="section">
            <h2>Section IX: Importing Class Rosters</h2>
            <Box sectionData={'start'} title={'Step 1: Create the Files to Import'} body={`Class rosters can be imported from properly formatted comma separated value (.csv or .gbr) files.
Create this file as follows:
1. Using a standard text editor such as TextEdit on OS X or Notepad on Windows create a blank
plain text file.
2. Begin by creating a header row as follows:
SurName,FirstName,MiddleName,ID,Email,Notes
a. There should be exactly five commas on each row. If there are more or less the row will
be ignored. To leave a field blank place two commas like in the following example (no
middle name, ID, or notes):
Smith,Joe,,,Joe@FakeMail.com,
3. Enter a newline (enter or return) at the end of each row. The last row should be blank.
4. Save the file with a .csv or .gbr extension to a known location.
Notes:
• A spreadsheet editor may be used to create the .csv file but care must be taken that exactly six
columns are created. Create one column for each entry in the header defined above. Name
the columns according to the header specified above (the first column should contain
‘SurName”, etc...
• If a student has multiple email addresses separate them with a semicolon (;).
• The import function will report the number of students created and ignored. Rows are ignored
if there is not a surname entry or if there are less than six columns.`} />


            <Box title={'Step 2: Copy the Files to the iOS Device'} body={`Note: Files can be selected without being copied to the device. Create the file as directed in step 1
and place the file in a location accessible from within an iOS document picker extension (iCloud
Drive, Dropbox, Google Drive, and Box are popular examples). Skip to step 3 and select ‘Other...’
from the ‘Import’ menu.
Files may be copied to the device using one of the two following methods before proceeding to step
3.
To transfer the files with Dropbox:
1. Login to Dropbox from GradeBook Pro on the destination iOS Device. This will create a
directory in your Dropbox at /GradeBook Pro/Import/Rosters/
2. Copy the files to be imported to the directory created in step 1.
3. On the “Data” screen, tap “Download Roster Import Files”. This will copy the files placed in the
directory to the /Documents directory of GradeBook Pro.
To transfer the files via email:
1. If the file was created with a .csv file extension, change it to .gbr.
2. Email the file(s) to an email address accessible on the destination iOS Device.
3. Open the email on the iOS Device.
4. Tap the file and then “Open in GradeBook Pro”.
5. The file will be sent to GradeBook Pro and is ready to be imported to a class roster.`} />

            <Box sectionData={'end'} title={'Step 3: Import the Files to a Class Roster:'} body={`The files are now ready to be imported to the class roster of choice by following the procedure
outlined in Section: Rosters and Students, Import Roster.`} />
        </div>
    )
}